import LegacyApiService from "./LegacyApiService";
class FileTokenService {
  getTokens() {
    return LegacyApiService.get("/issue-file-access-token");
  }
}

export default new FileTokenService();
